import { render, staticRenderFns } from "./discountApprovalPage.vue?vue&type=template&id=a9725b80&scoped=true"
import script from "./discountApprovalPage.vue?vue&type=script&lang=js"
export * from "./discountApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./discountApprovalPage.vue?vue&type=style&index=0&id=a9725b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9725b80",
  null
  
)

export default component.exports